import Vue from 'vue'

const SvgIcon = () => import('@/components/SvgIcon')

Vue.component('svg-icon', SvgIcon)
